<template>
  <div class="text-center" style="padding-left: 5%; padding-right:5%;">
    <h1 class="text-primary" :style="styles" :class="classes">{{ formattedValue }}<span :style="{'font-size': `50%`}">{{isPercentage ? '%' : ''}}</span></h1>
    <span>{{ label }}</span>
  </div>
</template>

<script>
import _color from '@/assets/utils/color';

export default {
  name: 'dashboard-statistic',
  props: {
    value: Number,
    label: String,
    color: {
      type: String,
      required: false
    },
    isPercentage: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    formattedValue () {
      if (this.value) {
        return Number.isInteger(this.value) ? this.value : Math.round(this.value);
      }
      return '0';
    },
    classes () {
      let classes = '';
      if (this.color) {
        if (_color.isColor(this.color)) {
          classes += ` text-${this.color}`;
        }
      }
      return classes;
    },
    styles () {
      const styles = {fontSize: '3.5rem'};
      if (this.color) {
        if (!_color.isColor(this.color)) {
          styles.color = _color.getColor(this.color);
        }
      }
      return styles;
    }
  }
};
</script>

<style scoped>

</style>
